import MyProjectCheckList from "../components/MyProjectCheckList"

const ProjectCheckList = () => {
  return (
    <div className="timesheet">
      <MyProjectCheckList/>
    </div>
  )
}

export default ProjectCheckList